import React from 'react';
import { Stack, Typography } from '@mui/material';
import { cleanUpID } from '../common/utils';
import PortalLink from '../common/PortalLink';

export function SafetyContacts(props) {
  return (
    <Stack
      id={props.id + '__stack_contactWrapper_' + props.data.id}
      key={props.id + '__stack_contactWrapper_' + props.data.id}
      direction="row"
      justifyContent={'space-between'}
    >
      <Typography id={props.id + '__text_title_' + props.data.id} className="phoneTitle">
        {props.data.title}
      </Typography>
      <PortalLink
        id={props.id + '__link_phone_' + props.data.id + '_' + cleanUpID(props.data.phoneNumber)}
        href={'tel:' + props.data.phoneNumber}
        className="phone noIcon"
        underline="hover"
        aria-label={
          'Call ' + props.campus.title + ' ' + props.data.title + ' at ' + props.data.phoneNumber
        }
      >
        {props.data.phoneNumber}
      </PortalLink>{' '}
    </Stack>
  );
}
